var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 33.41 36.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f7f7f7;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #34669b;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        fill: none;\n      }\n\n      .cls-4 {\n        stroke-width: 2.4px;\n      }\n\n      .cls-4, .cls-5 {\n        stroke: #34669b;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-5 {\n        stroke-width: 2.37px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    width: 30.01,
    height: 34.39
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.2,2.2c1.21,0,2.19.98,2.19,2.19v18.96c0,4.83-3.93,8.76-8.76,8.76H2.2V4.34c0-1.18.96-2.14,2.14-2.14h16.86M21.2,0H4.34C1.94,0,0,1.95,0,4.34v29.98h14.62c6.05,0,10.96-4.91,10.96-10.96V4.39C25.59,1.97,23.62,0,21.2,0h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5.7,
    y1: 8.1,
    x2: 19.56,
    y2: 8.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5.76,
    y1: 15.07,
    x2: 19.62,
    y2: 15.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 5.7,
    y1: 22.59,
    x2: 19.56,
    y2: 22.59
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.65,35.5c-5.8,0-10.52-4.72-10.52-10.52s4.72-10.52,10.52-10.52,10.52,4.72,10.52,10.52-4.72,10.52-10.52,10.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.65,15.47c5.24,0,9.5,4.26,9.5,9.5s-4.26,9.5-9.5,9.5-9.5-4.26-9.5-9.5,4.26-9.5,9.5-9.5M20.65,13.43c-6.38,0-11.55,5.17-11.55,11.55s5.17,11.55,11.55,11.55,11.55-5.17,11.55-11.55-5.17-11.55-11.55-11.55h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.44,17.51c4,0,7.25,3.25,7.25,7.25s-3.25,7.25-7.25,7.25-7.25-3.25-7.25-7.25,3.25-7.25,7.25-7.25M20.44,15.31c-5.22,0-9.45,4.23-9.45,9.45s4.23,9.45,9.45,9.45,9.45-4.23,9.45-9.45-4.23-9.45-9.45-9.45h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "16.14 25.2 19.4 28.23 25.66 22.42"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    width: 33.41,
    height: 34.32
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/uploadFile.c25c3acd6b8bcf37aefef28e76e3db61.svg";
export { ForwardRef as ReactComponent };